import React, {useEffect, useState} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Fido from '../utils/Fido';

const styles = makeStyles(theme => ({
  tab: {
    fontWeight: 400,
    position: 'relative',
  },
  circle: {
    position: 'absolute',
    top: 0, 
    left: 75, 
    backgroundColor: '#f9894b',
    color: theme.palette.common.white,
    borderRadius: '30%',
    width: 20,
    height: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: theme.typography.fontSize * 0.6, 

  },
}));

function NumberCircle(props) {
    const classes = styles();
    const [count, setCount] = useState([]);

  	function getEsclatedCount() {
      const fido = new Fido();   
      fido.fetch('/esclatedAlerts/esclatedCount', {
        method: "GET"
      })
        .then((data) => {
          setCount(data.count)
        })
        .catch(error =>  setCount(0));
    };
    
    useEffect(() => {
      getEsclatedCount();
    }, []);

    return (
      <div className={classes.tab}>
        <div className={classes.circle} id="eslcatedCount">
          {count}
        </div>
      </div>
    );
}


export default NumberCircle;
